export const CRITERIA_DATA_KEY = "criteriaData";
export const ONBOARDING_DATA_KEY = "onboardingData";
export const NON_AUTHENTICATED_USER_DATA_KEY = "nonAuthenticatedUserData";
export const TOKEN_KEY = "authToken";
export const LAST_SAVED_ONBOARDING_STEP_KEY = "lastSavedOnboardingStep";
export const USER_KEY = "user";
export const HOME_DETAIL_PAGE_VISITS = "homeDetailPageVisits";
